<template lang="pug">
nav.navbar(role="navigation" aria-label="main navigation")
  .container
    .header-container
      .navbar-left
        a.navbar-item.logo(href="/dashboard")
          img(src="@/assets/images/logolp.svg" height="118")
        .navbar-items
          a.navbar-item.menu-item-first(@click="showPage('dashboard')" :class="{'is-active-menu' : $route.name == 'Dashboard'}") Cotizaciones
          a.navbar-item(v-if="roleSupervisor" @click="showPage('dashboard-programs')" :class="{'is-active-menu' : $route.name == 'DashboardPrograms'}") Programas
      .navbar-center
        .navbar-item.search--box
          img(class="navbar-search-icon" src="../../assets/images/icon-search.svg")
          b-autocomplete(
            :loading="isFetching"
            @typing="getAsyncData"
            :data="searchData"
            class="navbar-search"
            placeholder="Busca por nro. de cotización, ramo o contratante"
            @select="option => selected = option")
            template(slot="empty") No hay resultados para la búsqueda.
            template(slot-scope="props")
              a(@click="openQuoteClickEvent(props.option.id)") {{returnName(props.option.product_name)}} / {{props.option.code}} / {{props.option.client}}
      .navbar-right
        .navbar-item.has-dropdown.is-hoverable.navbar-item--notice
          .navbar-link.is-arrowless
            .notification-component(v-if="!roleEmission")
              svg(xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 20 20" fill="#5d5d5d")
                path(d="M16 7a5.38 5.38 0 0 0-4.46-4.85C11.6 1.46 11.53 0 10 0S8.4 1.46 8.46 2.15A5.38 5.38 0 0 0 4 7v6l-2 2v1h16v-1l-2-2zm-6 13a3 3 0 0 0 3-3H7a3 3 0 0 0 3 3z" width="100%" height="100%")
              .notification-counter(v-if="getCount(notifications) > 0")
                .counter-wrapper {{getCount(notifications)}}
          .navbar-dropdown.is-right.is-boxed.is-list(v-if="notifications.length > 0")
            a.navbar-item(v-for="notification in notifications", 
              :class="{'is-unread': !notification.is_read}", 
              @click="openQuotation(notification)")
              .message-nt
                p {{notification.message}}
                p {{notification.created | formDate}}
        .navbar-item.has-dropdown.is-hoverable
          .navbar-link.username {{auth.user.full_name}}
          .navbar-dropdown.is-boxed
            a.navbar-item(v-if="roleAdministrator" @click="admin") Administrar
            a.navbar-item(v-if="roleTeamSupervisor" @click="team") Equipo
            a.navbar-item(v-if="!roleOperative && !roleEmission" href="/reports") Reportes
            a.navbar-item(@click="showUpdatePasswordView") Cambiar contraseña
            a.navbar-item(@click="logout") Salir 
</template>
<script>
import axios from 'axios'
import Auth from '@/mixins/auth'
import debounce from 'lodash/debounce'
import OnCreateNotifications from '@/queries/OnCreateNotifications'
import AuthRepository from '../../services/AuthRepository'

import { RepositoryFactory } from '@/services/RepositoryFactory'
import { isRoleAdministrator,
  isRoleTeamSupervisor,
  isRoleOperative,
  isBroker,
  isExecutive,
  isEmission,
  isRoleManager,
  isExecutiveManager,
  isTechnicalManager,
  } from '@/mixins/user';
import { isTechnical } from '../../mixins/user'
const QuoteRepository = RepositoryFactory.get('quotes')
const UserRepository = RepositoryFactory.get('user')


export default {
  data () {
    return {
      searchData: [],
      isFetching: false,
      notifications: []
    }
  },
  apollo: {
    $subscribe: {
      onCreateNotification: {
        query: () => OnCreateNotifications,
        result ({ data }) {
          this.syncNotifications()
        }
      },
    }
  },
  computed: {
    auth: function() {
      return this.$store.state.auth
    },
    showButtonNew() {
      return isExecutiveManager() || isEmission() || isTechnical()
    },
    roleAdministrator() {
      return isRoleAdministrator();
    },
    roleTeamSupervisor() {
      return isRoleTeamSupervisor();
    },
    roleOperative() {
      return isRoleOperative();
    },
    roleEmission() {
      return isEmission();
    },
    roleSupervisor(){
      return isExecutive()
    }
  },
  created() {
    this.syncNotifications()
  },
  methods: {
    
    returnName(name){
      if(name === "Programa estratégico (Multiriesgo/RC/3D)COPY")
      {
        return "Programa estratégico (Multiriesgo/RC/3D)"
      }else{
        return name
      }
    },
    syncNotifications () {
      UserRepository.getNotificationList().then((response) => {
        if (response.data) {
          this.notifications = response.data
        }
      }).catch(error => {
        if(error.response.status == 401 ) {
          Auth.removeSession()
          this.$store.commit('setAuth', null);
          this.$router.push('/');
        }
      })
    },

    getCount(notifications) {
      return notifications.filter(n => !n.is_read).length
    },

    showUpdatePasswordView() {
      this.$router.push('/cambiar-contrasena');
    },

    logout () {
      AuthRepository.logout().then((response) => {
        Auth.removeSession()
        this.$store.commit('setAuth', null);
        this.$router.push('/');
      }).catch(error => {
      })
    },

    admin() {
      this.$router.push('/administrator');
    },
    team() {
      this.$router.push('/team');
    },

    showPage(page){
      page == 'dashboard' || page == 'dashboard-programs'?
      this.$router.push('/'+page) :
      this.$router.push('/quotation/'+page);
    },
    openQuotation (notification) {
      if (!notification.is_read) {
        UserRepository.readNotification(notification.source_id).then((response) => {
          if (response.data) {
            this.notifications = response.data
            this.$router.push({ name: 'QuotationDetail', params: { id: notification.source_id }})
          }
        })
      } else {
        this.$router.push({ name: 'QuotationDetail', params: { id: notification.source_id }})
      }
    },
    openQuoteClickEvent(code) {
      this.$router.push({ name: 'QuotationDetail', params: { id: code }})
    },
    getAsyncData: debounce(function (q) {
      if (!q.length) {
        this.searchData = []
        return
      }
      this.isFetching = true
      QuoteRepository.search(q)
        .then(({ data }) => {
          this.searchData = []
          if (data) {
            data.forEach((item) => this.searchData.push(item))
          }
        })
        .catch((error) => {
          this.searchData = []
          throw error
        })
        .finally(() => {
          this.isFetching = false
          this.searchData.reverse();
        })
    }, 500)
  }
}
</script>

<style lang="scss">
  .notification-component {
    .notification-counter {
      width: fit-content;
      position: absolute; 
      text-align: center; bottom: 60%; 
      left: 68%; transform: translate(-50%, 40%); 
      border-radius: 3px;
      background-color: red; 
      color: white; 
      font-size: 8px; 
      padding: 1.5px 3px;
    }
  }
  .counter-wrapper {
    font-weight: bold;
  }
  .message-nt {
    width: 300px;
    white-space: pre-wrap;
    font-size: 0.9em;
  }
  .is-list {
    max-height: 600px;
    overflow-x: auto;
  }
  .navbar {
    border-bottom: 1px solid #eae8e8;
    -webkit-box-shadow: -1px 0 3px 0 #e6e6e6;
    box-shadow: -1px 0 3px 0 #e6e6e6;

    /*.search--box {
      width: 50%;
      .autocomplete {
        width: 60%;
      }
    }*/

    .username {
      text-overflow: ellipsis;
      width: 250px;
      display: block;
      overflow: hidden;
      white-space: nowrap;
      padding: 1.2em 2em;
    }

    .dashboard {
      text-overflow: ellipsis;
      width: auto;
      display: block;
      overflow: hidden;
      white-space: nowrap;
      padding: 1.7em 1em;
    }

    .navbar-link.dashboard::after{
      display: none;
    }

    .navbar-link::after{
      width: 0 !important;
      height: 0 !important;
      border-style: solid !important;
      border-width: 10px 8.5px 0 8.5px !important;
      border-color: #FF6D46 transparent transparent transparent !important;
      transform: none !important;
    }

    .navbar-item--notice{
      padding-right: 30px;
    }

    .navbar-item{
      &:hover{
        color: #FF6D46;
      }
      &.is-active-menu {
        border-bottom: 2px solid #FF6D46;
        color: #FF6D46;
      }
    }
    a.navbar-item {

      &.is-unread {
        background-color: #fff7f0;
        font-weight: bold;
      }

      &.is-active {
        border-bottom: 2px solid #00cec5;
      }
      &.logo {
        img {
          max-height: 3em;
        }
      }
    }
  }

  .navbar-items{
    display: flex;
    align-items: flex-end;
    padding-left: 55px;
    box-sizing: border-box;
  }

  .menu-item-first{
    margin-right: 30px;
  }

  .navbar-left{
    display: flex;
  }

  .navbar-center{
    width: 38%;
    display: flex;
    align-items: center;
  }

  .navbar-item.search--box{
    width: 100%;
    display: block;
  }

  .navbar-right{
    display: flex;
  }

  .header-container{
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    width: 100%;
  }

  .navbar-search-icon{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 20px;
    z-index: 10;
    pointer-events: none;
  }

  .navbar-search input{
    padding-left: 50px !important;
    box-sizing: border-box;
  }

  @media screen and (max-width: 1400px){
    .navbar .navbar-item--notice{
      padding-right: 0;
    }

    .navbar-items{
      padding-left: 20px;
    }

    .menu-item-first{
      margin-right: 15px;
    }

    .navbar-center{
      width: 30%;
    }
  }

  @media screen and (max-width: 1023px){
    .navbar-center{
      display: none;
    }
    .navbar-right{
      display: none;
    }

    .navbar-items{
      display: none;
    }
  }

  .autocomplete {
    .control {
      .input {
          box-shadow: none;
          border: 1px solid #e8e8e8;
          border-radius: 5px;
          height: 40px;
          padding: 10px;
          font-size: 14px;
          &:focus {
              box-shadow: none;
          }
      }
    }
  }

  .navbar-search-icon{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 30px;
    z-index: 10;
    pointer-events: none;
  }

</style>
